import {
	BookOpen,
	BookText,
	CircleDollarSign,
	FlaskConical,
	HeartPulse,
	LayoutDashboard,
	MessagesSquare,
	Route,
	ShieldCheck,
	Wrench,
} from 'lucide-react';

import { ROUTES } from './routes';

import type { NavSection } from './navigation.types';

/** Grouped by operator intent, not by backend structure. */
export const NAV_SECTIONS: NavSection[] = [
	{
		labelKey: 'SECTION_OPERATION',
		filtersByModule: true,
		items: [
			{ to: ROUTES.today, labelKey: 'nav.today', shortcut: 'G D', icon: LayoutDashboard },
			{ to: ROUTES.conversations, labelKey: 'nav.conversations', shortcut: 'G C', icon: MessagesSquare },
			{ to: ROUTES.quality, labelKey: 'nav.quality', shortcut: 'G Q', icon: ShieldCheck },
		],
	},
	{
		labelKey: 'SECTION_HOW_IT_ANSWERS',
		items: [
			{ to: ROUTES.routing, labelKey: 'nav.routing', shortcut: 'G A', icon: Route },
			{ to: ROUTES.tools, labelKey: 'nav.tools', shortcut: 'G T', icon: Wrench },
			// Reading the corpus takes `show`; acting on it is gated inside.
			{
				to: ROUTES.knowledge,
				labelKey: 'nav.knowledge',
				shortcut: 'G K',
				icon: BookOpen,
				permission: (p) => !!p.show,
			},
		],
	},
	{
		labelKey: 'SECTION_BUSINESS',
		items: [{ to: ROUTES.costs, labelKey: 'nav.costs', shortcut: 'G O', icon: CircleDollarSign }],
	},
	{
		labelKey: 'SECTION_SYSTEM',
		items: [
			{ to: ROUTES.lab, labelKey: 'nav.lab', shortcut: 'G L', icon: FlaskConical },
			{ to: ROUTES.health, labelKey: 'nav.health', shortcut: 'G S', icon: HeartPulse },
			{ to: ROUTES.glossary, labelKey: 'nav.glossary', shortcut: 'G B', icon: BookText },
		],
	},
];
